import { IxChain } from "@shared/src/config/chains";
import { Connector } from "@shared/src/lib/types";
import { wagmiConfig } from "@shared/src/config/wagmiConfig";
import { getClient } from "@wagmi/core";

function toHexString(number: number) {
  return `0x${number.toString(16)}`;
}

export const handleSwitch = async (chain: IxChain) => {
  const chainIdHex = toHexString(chain.id);
  const client = getClient(wagmiConfig);
  const request = client?.request;
  if (!request) {
    throw new Error("client not found in handleSwitch");
  }
  try {
    await request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: chainIdHex }],
    });
  } catch (error: any) {
    console.error("Direct switch chain error:", error);
    if (error.code === 4902) {
      // Chain not added, try adding it
      await request({
        method: "wallet_addEthereumChain",
        params: [
          {
            chainId: chainIdHex,
            chainName: chain.name,
            nativeCurrency: {
              name: chain.nativeCurrency.name,
              symbol: chain.nativeCurrency.symbol,
              decimals: chain.nativeCurrency.decimals,
            },
            rpcUrls: chain.rpcUrls.default.http,
            blockExplorerUrls: [chain.blockExplorers?.default.url || ""],
          },
        ],
      });
      // Retry switching
      await request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: chainIdHex }],
      });
    }
  }
};
